import { Injectable } from '@angular/core';
import { RoleLimitsService } from './role-limits.service';
import { VariantRoleAssignmentLimit } from '@markant-platform/authorizer/model';

@Injectable({
  providedIn: 'root',
})
export class DisabledRoleLimitsStrategyService implements RoleLimitsService {
  buildLimit(): VariantRoleAssignmentLimit {
    return {
      allowsAssignment: true,
    };
  }

  incrementLimits(): VariantRoleAssignmentLimit | undefined {
    return undefined;
  }

  decrementLimits(): VariantRoleAssignmentLimit | undefined {
    return undefined;
  }
}
